import { render } from "./ComposerView.vue?vue&type=template&id=038ac372"
import script from "./ComposerView.vue?vue&type=script&lang=js"
export * from "./ComposerView.vue?vue&type=script&lang=js"

import "./ComposerView.vue?vue&type=style&index=0&id=038ac372&lang=css"

import exportComponent from "/home/simon/workspace/tasman/3palette/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__